// extracted by mini-css-extract-plugin
module.exports = {"searchTap":"SearchTap_search-tap__WXEXD"};